//export const SIDEBAR_MENU_DATA = "System/GetMenuTreeListByUserGuid"
export const SIDEBAR_MENU_DATA = "System/GetMenuTreeList"